module.exports = __webpack_public_path__ + "img/cal-diners.b5df4a54.png";